module.exports = __webpack_public_path__ + "img/9.f7c7f16a.jpg";